module.exports = __webpack_public_path__ + "img/as.e753c5e.svg";